import React, {useState, useEffect, useContext, useCallback} from 'react';
import CommandsContext from '../../../context/commandsContext';
import MenuContext from '../../../context/menuContext';
import useKeyPress from '../../../hooks/useKeyPress';
import BodyContentView from '../../views/bodyContentView';
import SensorFailed from '../info/sensor-failed';

function Acknowledge({onExit}) {
  const {
    setShowAck,
    setShowInfo,
    setsensorError,
    showAck,
    showInfo,
    sensorError,
    onComponent,
    info,
    onShowMenu,
    alert,
    list,
    setInfo,
    setList,
  } = useContext(MenuContext);

  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {onUpdateCommands} = useContext(CommandsContext);

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;
    onRight();
  }, [rightPress]);

  const onLeft = useCallback(() => {
    if (onShowMenu) {
      onShowMenu(false);
    }

    setShowAck(false);
    onComponent(null);
    setsensorError(true);
  }, []);

  const onRight = useCallback(() => {
    if (onShowMenu) {
      onShowMenu(false);
    }
    setShowAck(false);
    setInfo(true);
    onComponent(null);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      onUpdateCommands({onLeft, onRight});
    });
  }, [onLeft, onRight]);

  useEffect(() => {
    if (alert === false) {
      onExit();
      setInfo(false);
    }
  }, [alert]);

  return (
    <BodyContentView
      title="Acknowledge"
      left="No"
      right="Yes"
      caption="Do you want to acknowledge this alert? It will appear in Alert History but will no longer
      appear on the display unless it clears and then re-occurs"
    />
  );
}

export default Acknowledge;
